<app-dialog [showCloseBtn]="true" size="medium">
  <section class="loan-editor" dialogContent>
    <h2 class="loan-editor-header fw-bold text-center">{{ 'CHANGE_PARAMS_LOAN' | translate }}</h2>
    <div [formGroup]="form" class="loan-editor-content">
      <div class="loan-editor-calculate">
        <app-calculate-widget
          (calculateChangeEvent)="calculateChangeHandler($event)"
          [amount]="amount"
          [product]="product"
          [term]="term"
          formGroupName="calculate"
        ></app-calculate-widget>
      </div>
      <div class="promo">
        <p (click)="showPromo()" class="promo-btn text-center cursor-pointer">{{ 'LOAN.BOOKING.PROMO_LABEL' | translate }}</p>
        <div *ngIf="isShowPromo" class="promo-field">
          <app-promo-code
            [isDisabled]="isDisabledPromo"
            [isSpinner]="showSpinner"
            [maxCodeLength]="MIN_CODE_LENGTH"
            [message]="message"
            [placeholder]="'LOAN.BOOKING.PROMO_PLACEHOLDER' | translate"
            formControlName="code"
          ></app-promo-code>
        </div>
      </div>
      <div class="d-flex justify-content-center mt-3">
        <app-button
          (clickEvent)="setChanges()"
          [label]="'BUTTON.EMPLOY' | translate"
          class="w-100"
          classes="fs-18 fw-medium"
          color="primary"
          size="w100"
        >
        </app-button>
      </div>
      <div class="w-100 mt-3">
        <app-loan-schedule-widget
          [character]="'WORKTABLE'"
          [preview]="preview$ | async"
          [schedule]="schedule$ | async"
        ></app-loan-schedule-widget>
      </div>
    </div>
  </section>
</app-dialog>
